import { useState, useEffect } from 'react';

export const usePersistentFilter = (key, defaultValue = {}) => {
  const [filters, setFilters] = useState( () => {
    return JSON.parse(localStorage.getItem("filterString"));
  });

  const resetFilters = (overrides = {}) => setFilters({...defaultValue, ...overrides});

  return [filters, setFilters, resetFilters];
};